import { useComponentTranslation } from '@tebuto/functions/translation.components'
import Heading from '@tebuto/typography/Heading'
import LargeText from '@tebuto/typography/LargeText'
import { CalendarXIcon } from 'lucide-react'
import { Therapist } from './types'

interface LimitExceededProps {
    therapist: Therapist
}

export default function LimitExceeded({ therapist }: LimitExceededProps) {
    const { t } = useComponentTranslation()
    return (
        <div className="flex items-center gap-6">
            <div className="grid gap-2">
                <CalendarXIcon className="w-12 h-12 widget-text-primary-color-600 shrink-0" />
                <div>
                    <Heading level={2}>{t('booking.limitExceeded.title')}</Heading>
                    <LargeText className="widget-text-secondary">
                        {t('booking.limitExceeded.description', {
                            firstName: therapist.firstName,
                            lastName: therapist.lastName
                        })}
                    </LargeText>
                </div>
            </div>
        </div>
    )
}
